import {useEffect} from "react";
import {useLocation} from "react-router-dom";

import {pageviewUserComHit} from "./user_com/hit_user_com";

export const usePageview = (callback?: () => void) => {
    const location = useLocation();
    useEffect(() => {
        if (callback) {
            callback();
        }
        pageviewUserComHit();
    }, [location.key]);
};
